import * as React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import Layout from 'src/components/organisms/Layout'
import SEO from 'src/utils/seo'

import type {ReactJSXElement} from '@emotion/react/types/jsx-namespace'

interface Props {
  postType: string
  heroContent: () => ReactJSXElement
  postsListContent: () => ReactJSXElement
}

const SearchResults = ({
  postType = 'Search Results',
  heroContent: HeroContent,
  postsListContent: PostsListContent,
}: Props) => {
  return (
    <Layout>
      <SEO title={`NCFX | ${postType}`} />
      <HeroContent />
      <Box>
        <Container maxWidth="lg" sx={{py: 6}}>
          <PostsListContent />
        </Container>
      </Box>
    </Layout>
  )
}

export default SearchResults
